import React from "react";
import { Moment, MomentInput } from "moment";
import { Phone } from "../../lib/interfaces/Phone";
import { AnyObject } from "../../lib/interfaces/AnyObject";

type HandleCreateEmailVersion = (props: {
  fromDate: string;
  emailData: { id: number; email: string };
  force: boolean;
}) => void;
type CreateIndividualPhone = (prop: { phone: Phone }) => void | Promise<Phone[]>;
type CreateEmail = (email: { fromDate: string; email: string }[]) => void | Promise<Phone[]>;
type CreateOrganizationPhone = (prop: { phone: Phone }) => void | Promise<Phone[]>;
type GetAccountPhonesVersions = (phoneId: number) => void | Promise<Phone[]>;
type GetIndividualVersions = () => void | Promise<Phone[]>;
type FetchSubscriberVersions = (subscribersId: number[]) => void | Promise<Phone[]>;
type HandleCreateSubscriberVersion = (
  subscriberId: number,
  fromDate: Moment,
  value: {
    accountId: number;
    externalId: string;
    id: number;
    subscriberTypeId: number;
  }
  // ,
  // isNeededRetarification?: boolean
) => void;
type HandleCloseSubscriberVersion = (subscriberId: number, toDate: Moment) => void;
type FetchEmailVersions = (emailsIds: number[]) => void | Promise<Phone[]>;
type UpdateAccountPhone = (prop: {
  phoneId: number;
  fromDate: string;
  force: boolean;
  phone: Phone;
}) => void | Promise<Phone[]>;
type HandleCloseEmailVersion = (emailId: number, toDate: string) => void;
type HandleUpdateIndividual = (props: {
  fromDate: MomentInput;
  data: {
    lastName: string;
    firstName: string;
    middleName: string;
    sex: string;
    birthDate: string | null;
  };
  force: boolean;
}) => void;
type HandleCloseIndividual = (fromDate: MomentInput) => void;
type ChangeAccountVersion = (accountStatusId: number, fromDate: string, accTypeId: number) => void;
type GetAccountVersions = () => void;
type UpdateIndividualDocument = (prop: {
  document: {
    id: number;
    docTypeId: number;
    docNum: string;
    seriesNum: string;
    issueEntity: string;
    issueCountry: number;
    issueDate: string;
    info?: string;
    dsc?: string;
    tenantId: 0;
  };
}) => void;
type FetchAddressVersions = (props: { addressId: number; addressType: string }) => void;
type ChangeAddressVersion = (props: {
  addressId: number;
  fromDate: string;
  addressObj: AnyObject;
  addressType: "legalAddress" | "actualAddress";
  force: boolean;
}) => void;

type CloseAccountPhone = (prop: { phoneId: number; fromDate: string }) => void | Promise<Phone[]>;

interface IAccountInfoContainerContext {
  accountId: number;
  createIndividualPhone: CreateIndividualPhone;
  createEmail: CreateEmail;
  handleCreateEmailVersion: HandleCreateEmailVersion;
  handleCloseEmailVersion: HandleCloseEmailVersion;
  createOrganizationPhone: CreateOrganizationPhone;
  getAccountPhonesVersions: GetAccountPhonesVersions;
  getIndividualVersions: GetIndividualVersions;
  fetchSubscriberVersions: FetchSubscriberVersions;
  handleCreateSubscriberVersion: HandleCreateSubscriberVersion;
  handleCloseSubscriberVersion: HandleCloseSubscriberVersion;
  fetchEmailVersions: FetchEmailVersions;
  updateAccountPhone: UpdateAccountPhone;
  handleUpdateIndividual: HandleUpdateIndividual;
  handleCloseIndividual: HandleCloseIndividual;
  changeAccountVersion: ChangeAccountVersion;
  getAccountVersions: GetAccountVersions;
  updateIndividualDocument: UpdateIndividualDocument;
  fetchAddressVersions: FetchAddressVersions;
  changeAddressVersion: ChangeAddressVersion;
  closeAccountPhone: CloseAccountPhone;
  getAccountTypePropertyVersions: (id: number) => void;
}

export const AccountInfoContainerContext = React.createContext<IAccountInfoContainerContext | null>(
  null
);

export const useAccountInfoContainerContext = () => {
  const context = React.useContext(AccountInfoContainerContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
